module.exports = __webpack_public_path__ + "media/images/contents/richmenu/no_image-27d99fd87873227b7606c1b14968967b.png";